import { render } from "./PDFTestObject.vue?vue&type=template&id=9b8ef00c"
import script from "./PDFTestObject.vue?vue&type=script&lang=js"
export * from "./PDFTestObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__